import React from "react";
import { Button, FormGroup, InputGroup, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import css from "./styles.module.scss";

interface ICustomerSearchInputProps {
  value: string;
  disabled: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSearch: () => void;
}

const CustomerSearchInput: React.FC<ICustomerSearchInputProps> = ({
  value,
  disabled,
  onChange,
  onSearch
}) => {
  return (
    <div className="column is-one-fifth">
      <FormGroup>
        <div className={css.formGroupLabel}>Customer ID</div>
        <InputGroup
          style={{ width: "10em" }}
          placeholder="0000000000"
          value={value}
          onChange={onChange}
        />
      </FormGroup>
      <Button
        style={{ width: "10em" }}
        icon={IconNames.SEARCH}
        intent={Intent.PRIMARY}
        onClick={onSearch}
        disabled={disabled}
      >
        Run Query
      </Button>
    </div>
  );
};

export default CustomerSearchInput;
